import { TabSwitcher } from '@/src/components/TabSwitcher'
import { LoadPlanningConsumption } from '@/src/features/procurement-and-markets/load-planning/LoadPlanningConsumption'
import { LoadPlanningLocationSelect } from '@/src/features/procurement-and-markets/load-planning/components/LoadPlanningLocationSelect/LoadPlanningLocationSelect'
import { LoadPlanningAdjustmentTablePage } from '@/src/features/procurement-and-markets/load-planning/load-planning-adjustments/table/LoadPlanningAdjustment.page'
import { FlexCol, FlexRow } from '@components'
import { useTabNavigation } from '@hooks/useTabNavigation.hook'
import { TABS } from '@utils/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const LoadPlanningRightSection = () => {
  const { t } = useTranslation()
  const { selectedTab, handleTabChange } = useTabNavigation(TABS.forecasting, {
    replaceOnPush: true,
  })

  const tabOptions = useMemo(
    () => [
      {
        label: t('components.procurement.forecasting.tab_header_consumption'),
        value: TABS.forecasting.verbrauch,
        dataAction: 'loadplan-consumption-tab',
      },
      {
        label: t('components.procurement.forecasting.tab_header_adjustment'),
        value: TABS.forecasting.anpassungen,
        dataAction: 'loadplan-adjustments-tab',
      },
    ],
    [t]
  )

  const handleTabSwitcherChange = (_e: React.ChangeEvent<HTMLElement>, option: { value: string }) => {
    const tabIndex = tabOptions.findIndex(tab => tab.value === option.value)
    if (tabIndex !== -1) {
      handleTabChange(tabIndex)
    }
  }

  return (
    <FlexCol gap={4} width='100%'>
      <FlexRow justifyContent='start' alignItems='center' gap={4}>
        <TabSwitcher colorScheme='primary' options={tabOptions} value={selectedTab} onChange={handleTabSwitcherChange} />
        <LoadPlanningLocationSelect />
      </FlexRow>

      {selectedTab === TABS.forecasting.verbrauch && <LoadPlanningConsumption />}
      {selectedTab === TABS.forecasting.anpassungen && <LoadPlanningAdjustmentTablePage />}
    </FlexCol>
  )
}
